import { memo } from 'react';
import { Typography } from 'antd';

import { Auction } from 'models/auction/Auction';
import TitleDescriptionList from './TitleDescriptionList';

const { Title } = Typography;

interface AuctionPaymentProps {
  auction: Auction;
}

function AuctionPayment({ auction }: AuctionPaymentProps) {
  const paymentInfo = [
    {
      key: 'payment',
      title: '결제 정보',
      description: '개인정보 보호를 위해 낙찰자에게만 이메일로 개별 안내 드립니다.',
    },
    {
      key: 'endsAt',
      title: '환불 규정',
      description: auction.return_policy,
    },
  ];

  return (
    <>
      <Title level={4}>결제 정보</Title>
      <TitleDescriptionList datalist={paymentInfo} />
    </>
  );
}

export default memo(AuctionPayment);
